import addDays from 'date-fns/add_days';
import startOfDay from 'date-fns/start_of_day';
import startOfMinute from 'date-fns/start_of_minute';
import addMinutes from 'date-fns/add_minutes';

import {changeDate, changeMinute} from './actions';

const scheduleDateChange = (store) => {
  const date = new Date();
  const tomorrow = startOfDay(addDays(date, 1));
  const milisecondsUntilTomorrow = tomorrow - date;

  setTimeout(() => {
    store.dispatch(changeDate(tomorrow));
    scheduleDateChange(store);
  }, milisecondsUntilTomorrow);
};

const init = (store) => {
  scheduleDateChange(store);

  const date = new Date();

  const nextMinute = startOfMinute(addMinutes(date, 1));

  const updateMinute = () => {
    store.dispatch(changeMinute(new Date()));
  };

  setTimeout(() => {
    setInterval(() => {
      updateMinute();
    }, 60 * 1000);
  }, nextMinute - date);
};


export default init;



// WEBPACK FOOTER //
// ./src/modules/now/init.js